import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emissions combined`,
  'consumption.energy': 'Power consumption in combined test cycle',
  'consumption.fuel': 'Fuel consumption combined',
  'footnotes.local': '',
  'footnotes.wltp': `De vermelde waarden zijn gemeten volgens de voorgeschreven meetmethode. Het betreft ‘WLTP-${co2}-waarden’ conform Art. 2 Nr. 3 van de doorvoerverordening (EU) 2017/1153. De waarden van het brandstofverbruik zijn op basis van deze waarden bepaald. Het stroomverbruik werd berekend op basis van VO 683/2008/EG. De opgaven hebben geen betrekking op een specifiek voertuig, ze zijn slechts bedoeld ter vergelijking van verschillende voertuigen onderling. De waarden variëren al naargelang de gekozen opties.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Uw zoekterm / Configurator OnlineCode',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'Geen zoekresultaten | {count} Zoekresultaat | {count} Zoekresultaten',
  'search.results.count': '{count} Zoekresultaten',
  'search.results.backup': "Geen exacte overeenkomsten gevonden. Bekijk gerelateerde pagina's:",
  'search.results.none.summary':
    'Er zijn geen zoekresultaten beschikbaar voor deze zoekterm. Probeer het opnieuw met een andere term.',
  'search.show-more': 'Bekijk meer.',
  'search.unavailable': 'Zoeken is momenteel niet beschikbaar.',
  'search.result.new': 'Nieuw',
  'input.placeholder': 'Uw zoekterm / Configurator OnlineCode',

  'search.result.consumption': 'Verbruik',
  'watch.video': 'Bekijk de video',
  'input.recently': 'Onlangs naar gezocht',
  'input.help.title': 'Waarnaar moet u zoeken?',
  'input.help.text':
    'Zoek aan de hand van voertuigtypen, modellen of configuratiecodes naar accessoires, andere producten en informatie',

  // new part
  'suggestions.all_search_results': 'Alle zoekresultaten',
  'suggestions.all_search_results_for': 'Toon alle resultaten voor',
  'suggestions.in': 'in',

  all: 'Allemaal',
  UCOS: 'Occasions Online Store',
  PASSENGER_CARS: 'Personenwagen',
  VANS: 'Vans',
  NCOS: 'Nieuwe auto Online Store',
  VIDEO: "Video's",
  DEALER_LOCATOR: 'Dealer zoeken',
  CONFIGURATOR: 'Configureer uw auto',
  TEST_DRIVE: 'Proefrit',
  VEHICLE_SEARCH: 'Occasion zoeken',
  COLLECT: 'Collection & Zubehör',
  CONNECT: 'Collection en accessoires',
  didyoumean: 'Bedoelt u',
  ACCESSORIES: 'Autozubehör',

  // No results found
  'support.check': '',
  'support.no.results': '',
  'support.no.results.term': 'Geen resultaten gevonden',
  'support.chat': '',
  'support.chat.with.us': 'online-chat-support',

  'search.results.offer': 'Populaire aanbiedingen voor "{query}":',
};
